<template>
  <EditTypeDialog
    ref="dialog"
    @saved="(e) => $emit('saved', e)"
  />
</template>

<script>
import EditTypeDialog from './EditTypeDialog'

export default {
  components: {
    EditTypeDialog
  },
  emits: ['saved'],
  data () {
    return {
      viewingType: null
    }
  },
  methods: {
    open () {
      this.$refs.dialog.open({
        name: null,
        client_title: null,
        client_description: null,
        shorthand_name: null,
        must_be_staffed: true,
        title: null,
        description: null,
        staff_reminder_offset: [],
        client_reminder_offset: [-1440],
        unscheduled_reminder_offset: [],
        time_allocation: 120,
        inventory: [],
        recursion_rule: null,
        recurring_status: 'UNSCHEDULED',
        color: '#027be3',
        required_form_template_ids: [],
        required_form_templates: [],
        checklist_template_ids: [],
        checklist_templates: []
      })
    }
  }
}
</script>
